import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { fetchESystemList } from 'apis/Service';
import ESystemTable from 'components/grid-table/tables/ESystemTable';
import ESystemMobileTable from 'components/grid-table/tables/ESystemMobileTable'; // 모바일용 테이블 컴포넌트 임포트
import ButtonBox from 'components/ui-component/box/ButtonBox';
import EsystemCalendar from 'components/ui-component/calendar/EsystemCalendar';
import { useCommon } from 'hooks/hooksCommon';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const ESystemList = () => {

    // ********************************************
    //  공통 & Redux & 모달
    // ********************************************
    const { navigate } = useCommon();
    const [tableData, setTableData] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // 모바일 환경 체크

    const params = useParams();
    const type = params.type;

    const types = [
        'leave',
        'vacation',
        'half-leave',
        'trip',
        'edu',
        'over',
        'absence',
    ]

    // 화면 크기 변경 감지
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        
        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        fetchESystemList(type).then(res => {
            if (res) {
                setTableData(res);
            } else {
                setTableData([]);
            }
        }).catch(err => {
            console.error(err);
            setTableData([]);
        });
    }, [type]);

    return (
        <Box>
            <Box>
                <ButtonBox sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="outlined" color="primary" onClick={() => {
                        navigate(`/e-system/form?type=${type}`);
                    }}>기안추가</Button>
                </ButtonBox>
            </Box>
            <Box sx={{ width: '100%', height: '100%' }}>
                {isMobile ? (
                    <ESystemMobileTable vtableData={tableData} />
                ) : (
                    <ESystemTable vtableData={tableData} />
                )}
            </Box>
            {/* <Box>
                <EsystemCalendar vData={tableData} />
            </Box> */}
        </Box>
    );
};

export default ESystemList;